import { TrendingUp, TrendingDown, Minus, Users, Calendar, MessageCircle, Award, DollarSign, BadgeCheck, CalendarRange } from "lucide-react";
import { Trans, useTranslation } from "react-i18next";

// Keys match what `delphi_kpi_view_6w` exposes.
const KPIS = [
  { key: "presence_pct",        i18n: "kpi.presence",       icon: Users,         suffix: "%", color: "text-blue-700" },
  { key: "invites_amenes",      i18n: "kpi.guests",         icon: Calendar,      suffix: "",  color: "text-amber-700" },
  { key: "recos_total",         i18n: "kpi.recos",          icon: MessageCircle, suffix: "",  color: "text-emerald-700" },
  { key: "recos_signees",       i18n: "kpi.recos_signed",   icon: BadgeCheck,    suffix: "",  color: "text-emerald-900" },
  { key: "taux_signature_pct",  i18n: "kpi.signature_rate", icon: Award,         suffix: "%", color: "text-purple-700" },
  { key: "one_on_one",          i18n: "kpi.one_on_one",     icon: Users,         suffix: "",  color: "text-pink-700" },
  { key: "business_signe",      i18n: "kpi.business_signed", icon: DollarSign,   suffix: "€", color: "text-apollo-orange-dark", format: "currency" },
];

function formatVal(v, k, locale) {
  if (v === undefined || v === null) return "n/a";
  if (k.format === "currency") return `${Math.round(v).toLocaleString(locale === "en" ? "en-GB" : "fr-FR")}`;
  return v;
}

export default function KPIDashboard({ latest, previous, window: kpiWindow, testId = "kpi-dashboard" }) {
  const { t, i18n } = useTranslation();
  const locale = (i18n.language || "fr").startsWith("en") ? "en" : "fr";

  if (!latest) {
    return (
      <div className="text-sm text-text-secondary" data-testid={testId}>
        {t("kpi.none_available")}
      </div>
    );
  }

  return (
    <div className="space-y-3" data-testid={testId}>
      {kpiWindow?.start && kpiWindow?.end && (
        <div
          className="flex items-center gap-2 text-xs text-text-secondary bg-bg-soft border border-border rounded-md px-3 py-2"
          data-testid="kpi-window-label"
        >
          <CalendarRange className="w-3.5 h-3.5 text-apollo-orange-dark" />
          <span>
            <Trans
              i18nKey="kpi.window_label"
              values={{ start: kpiWindow.start, end: kpiWindow.end }}
              components={{ strong: <strong /> }}
            />
          </span>
        </div>
      )}
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {KPIS.map((k) => {
          const Icon = k.icon;
          const cur = latest[k.key];
          const prev = previous?.[k.key];
          let trend = 0;
          if (prev !== undefined && prev !== 0) trend = ((cur - prev) / Math.abs(prev)) * 100;
          const TrendIcon = trend > 2 ? TrendingUp : trend < -2 ? TrendingDown : Minus;
          const trendColor = trend > 2 ? "text-success" : trend < -2 ? "text-danger" : "text-text-secondary";

          return (
            <div key={k.key} className="bg-white border border-border rounded-lg p-3" data-testid={`kpi-${k.key}`}>
              <div className="flex items-center justify-between mb-1">
                <Icon className={`w-4 h-4 ${k.color}`} />
                <TrendIcon className={`w-3.5 h-3.5 ${trendColor}`} />
              </div>
              <div className="font-heading font-bold text-xl text-text-primary">
                {formatVal(cur, k, locale)}<span className="text-xs text-text-secondary font-medium ml-0.5">{k.suffix}</span>
              </div>
              <div className="text-xs text-text-secondary">{t(k.i18n)}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
